(ns machtfit.widgets.icon
  (:require
   [machtfit.core :as machtfit]))

(defn- icon-base [file name classes]
  (let [path (str file "#" name)]
    [:svg {:class classes}
     [:use
      {:href path
       ;; xlinkHref is deprecated in favor of href
       ;; it just stays for compatibility
       ;; https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/xlink:href
       :xlinkHref path}]]))

(defn static [name {:keys [height
                           width
                           class]
                    :or {height "h-6"
                         width "w-6"}}]
  (icon-base (machtfit/static "static-icons-sprite.svg") name [height width class]))

(defn outline [name {:keys [stroke
                            fill
                            height
                            width
                            class]
                     :or {stroke "stroke-current"
                          fill "fill-none"
                          height "h-6"
                          width "w-6"}}]
  (icon-base (machtfit/static "icons-sprite.svg") name [stroke fill height width class]))
